
import { useQuery} from '@apollo/client';

import { GET_ME } from '../queries/getMe';

export const useIsContentReviewer = () => {
  const { loading: meLoading , error: meError , data: me } = useQuery(GET_ME);

  return !meLoading && !meError && !!me?.me?.organisation?.membership?.isContentReviewer;
};

/**
 * The same test, but with the loading flag, for pages that redirect non-reviewers away.
 *
 * `useIsContentReviewer` can't tell "not a reviewer" from "GET_ME hasn't answered yet" — both
 * are `false` — so redirecting on it alone bounces a real reviewer during the initial load.
 * Gate on `!loading && !isContentReviewer` instead.
 */
export const useContentReviewerGate = () => {
  const { loading, error, data } = useQuery(GET_ME);

  return {
    loading,
    isContentReviewer: !loading && !error && !!data?.me?.organisation?.membership?.isContentReviewer,
  };
};
